export default __webpack_public_path__ + "static/media/divide.889cba16.svg";